<a
  class="link-reset featured-event-card-container"
  [routerLink]="['/agenda', event().id, event().startDate | date: 'dd-MM-yyyy', event().title]"
>
  <article class="featured-event-card">
    <figure class="featured-event-card__figure">
      @if (!event().videoUrl) {
        <fstr-image
          class="featured-event-card__figure__media"
          [image]="event().image"
          [fill]="true"
          [colSpan]="{
            xs: 12,
            md: 6,
          }"
        ></fstr-image>
      }
      @if (event().videoUrl) {
        <app-youtube
          class="featured-event-card__figure__media"
          [url]="event().videoUrl!"
          [cookiePreferences]="cookiePreferences()"
          [previewOnly]="true"
        ></app-youtube>
      }
    </figure>
    <main class="featured-event-card__main d-flex gap-2 align-items-center">
      <div class="flex-grow-1">
        <div class="d-flex gap-1 fs-body-xs featured-event-card__date mb-1">
          {{ event().startDate | eventDate: event().endDate }}
        </div>
        <h2 class="h5 fw-normal max-lines-3 mb-max-lines">{{ event().title }}</h2>
      </div>

      <div class="button--accent button button-icon button--lg flex-shrink-0">
        <fstr-icon anchor="line-icon-arrow-right"></fstr-icon>
      </div>
    </main>
  </article>
</a>
